import React, { useState, useEffect, useContext } from "react";
import { Card, Flex } from "antd-mobile";
import _ from 'lodash';
import "moment/locale/zh-cn";

import { Empty, Loading } from "../components";
import Permission from "../components/Permission";
import BasicContext from "../BasicContext";

import { getPercentFormat, getSthousandsFormatNum, renderCountryCNameByBrevityCode, formatBillUnit } from "../utils/common";
import * as Api from "../../../api/usms";
import { renderDateRange, timeFormatType } from "../utils/timeFormat";
import { UrlSearch, renderCompanyCNameByCompanyId, renderOrgCNameByOrgId } from "../../../utils/utils";
import { PurposeNumber } from "../utils/const";
import { AclKeys } from "../utils/permissions";

import "../index.css";

// const SortKey = {
// 	TotalCostCount: "发送总数",
// 	BillCount: "计费条数",
// 	SuccessPercent: "成功率"
// };


export default function StatisticDetail() {

	const context = useContext(BasicContext);
	const customerList = context.customers;
	const countryList = context.countryList;

	const [timeRange, setTimeRange] = useState([]);

	// 统计
	const [list, setList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const company_id = Number(UrlSearch("company_id"));
	const start_time = Number(UrlSearch("start_time"));
	const end_time = Number(UrlSearch("end_time"));

	useEffect(() => {
		initData();
	}, []);

	const initData = () => {
		setLoading(true);
		setTimeRange([start_time * 1000, end_time * 1000]);
		if (!company_id || !start_time || !end_time) {
			setErrorMessage("缺失参数");
			return;
		}
		const data = {
			CompanyId: [company_id],
			StartTime: start_time,
			EndTime: end_time
		};
		Api.GetCustomerStatistics(data)
			.then(res => {
				const { AccountAccumulateStatistics } = getAccountInfo(res)[0] || []
				const statistics = AccountAccumulateStatistics.sort((a, b) => b.CompanyRevenue - a.CompanyRevenue)
				setList(statistics);
				setErrorMessage("");
				setLoading(false);
			})
			.catch(e => {
				setLoading(false);
				setList([]);
				setErrorMessage(e.message || "获取数据失败");
			});
	};

	// 聚合Account统计信息
	const getAccountInfo = (list) => {
		return list.map((item) => {
		  if (!item.AccountStatistics || !Array.isArray(item.AccountStatistics) || item.AccountStatistics.length === 0) {
			return item;
		  }
	
		  const AccountStatistics = _.cloneDeep(item.AccountStatistics);
		  const results = AccountStatistics.reduce((accumulator, currentItem) => {
			const exists = accumulator.find(
			  (item) =>
				item.AccountId === currentItem.AccountId &&
				item.BrevityCode === currentItem.BrevityCode &&
				item.Purpose === currentItem.Purpose
			);
	
			if (exists) {
			  // 如果已存在，累加值
			  exists.TotalCount += +currentItem.TotalCount;
			  exists.AccountBillCount += +currentItem.AccountBillCount;
			  exists.CompanyRevenue += +currentItem.CompanyRevenue;
			  exists.ProductRevenue += +currentItem.ProductRevenue;
			  exists.SuccessCount += +currentItem.SuccessCount;
			  exists.Profits += +currentItem.Profits;
			} else {
			  // 如果不存在，将当前item添加到累积器中
			  accumulator.push(currentItem);
			}
	
			return accumulator;
		  }, []);
	
		  // 遍历计算成功率和利润率
		  results.forEach((item) => {
			item.SuccessPercent = ((item.SuccessCount / item.TotalCount) * 100).toFixed(1);
			item.ProfitPercent = ((item.Profits / item.CompanyRevenue) * 100).toFixed(1);
		  });
	
		  item.AccountAccumulateStatistics = results;
	
		  return item;
		});
	  };

	const getAlarmPercent = (text) => {
		const render = getPercentFormat(text, 100, 1);
		return render;
	};

	const renderList = () => {
		if (list.length === 0) {
			return <Empty />;
		}

		return list.map((item, index) => (
			<Card full style={{ marginBottom: "8px" }} key={index}>
				<Card.Header title={`${renderOrgCNameByOrgId(item.AccountId, customerList)}`} />
				<Card.Body>
					<div style={{ borderBottom: "1px solid #E9E9E9" }}>
						<Flex>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>短信类型：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>{PurposeNumber[item.Purpose]}</span>
							</Flex.Item>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>国家：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>
									{renderCountryCNameByBrevityCode(item.BrevityCode, countryList)}
								</span>
							</Flex.Item>
						</Flex>
						<Flex>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>发送总数：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>
									{getSthousandsFormatNum(item.TotalCount)}
								</span>
							</Flex.Item>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>计费条数：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>
									{getSthousandsFormatNum(item.AccountBillCount)}
								</span>
							</Flex.Item>
						</Flex>
						<Flex>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>成功率：</span>
								<span style={{ fontWeight: "bold", color: "#E67E22" }}>{getAlarmPercent(item.SuccessPercent)}</span>
							</Flex.Item>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>公司收入(美元)：</span>
								<span style={{ fontWeight: "bold", color: "#E67E22" }}>{getSthousandsFormatNum(formatBillUnit(item.CompanyRevenue))}</span>
							</Flex.Item>
						</Flex>
						<Flex>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>利润(美元)：</span>
								<span style={{ fontWeight: "bold", color: "#E67E22" }}>{getSthousandsFormatNum(formatBillUnit(item.Profits))}</span>
							</Flex.Item>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>利润率：</span>
								<span style={{ fontWeight: "bold", color: "#E67E22" }}>{getAlarmPercent(item.ProfitPercent)}</span>
							</Flex.Item>
						</Flex>
					</div>
				</Card.Body>
			</Card>
		));
	};

	return (
		<div className="container">
			<Permission aclKey={AclKeys.SalesBoard}>
				<h3 style={{ marginBottom: "10px" }}>{`${renderDateRange(
					timeRange,
					timeFormatType.date_xg
				)} 运营数据明细:`}</h3>
				<Loading loading={loading} error={errorMessage}>
					<h3 style={{ marginBottom: "10px" }}>{`${renderCompanyCNameByCompanyId(company_id, customerList)}`}</h3>
					{/* <div style={{ marginBottom: "10px" }}>
						<Radios
							value={sortKey}
							onChange={value => onSortChange(value)}
							type="ghost"
							activeType="ghost"
							options={Object.keys(SortKey).map(item => ({
								label: SortKey[item] + (sortKey === item ? (sortUp ? "↑" : "↓") : ""),
								value: item
							}))}
						/>
					</div> */}
					{renderList()}
				</Loading>
			</Permission>
		</div>
	);
}
